var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsBoolean, IsDateString, IsEnum, IsUUID } from 'class-validator';
import { FeatureFlagType } from '../enums/feature-flag-type.enum.js';
export class FeatureFlagFullSizeDto {
    id;
    createdAt;
    updatedAt;
    type;
    enabledGlobally;
    enabledForOffices;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], FeatureFlagFullSizeDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], FeatureFlagFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], FeatureFlagFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsEnum(FeatureFlagType),
    __metadata("design:type", String)
], FeatureFlagFullSizeDto.prototype, "type", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], FeatureFlagFullSizeDto.prototype, "enabledGlobally", void 0);
__decorate([
    Exclude(),
    __metadata("design:type", Array)
], FeatureFlagFullSizeDto.prototype, "enabledForOffices", void 0);
//# sourceMappingURL=feature-flag.full-size.dto.js.map